module.exports = __webpack_public_path__ + "img/icon-car.c543c770.svg";